import { Box } from "@material-ui/core";
import { DownloadButton } from "components/buttons/DownloadButtons";
import { DateTimeField } from "components/fields/DateFormatField";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { DeleteButton } from "components/toolbars/DeleteButton";
import {
	DefaultDocumentTemplateType,
	InvoiceDocumentTemplateType,
	CustomerDocumentTemplateType,
} from "entities/DocumentTemplateType";
import React from "react";
import { Datagrid, FunctionField, TextField, useTranslate } from "react-admin";

import { AddDocumentTemplate } from "./AddDocumentTemplate";
import { TemplateInfoPreviewButton, TemplateInfoPreviewDialog } from "./TemplateInfoPreviewButton";
import { UpdateDocumentTemplate } from "./UpdateDocumentTemplate";

const TheTemplateInfoPreviewButton = ({
	record,
	translate,
	infoDialogToggle,
	setSelectedRecord,
}) => {
	const handleOnClick = () => {
		setSelectedRecord(record);
		infoDialogToggle();
	};
	return <TemplateInfoPreviewButton translate={translate} onInfoButtonClick={handleOnClick} />;
};

export const DocumentTemplateList = (props) => {
	const [isInfoDialogOpen, setIsInfoDialogOpen] = React.useState(false);
	const [selectedRecord, setSelectedRecord] = React.useState({});
	const companyId =
		!props.isDefaultDocTemplate && !props.isDefaultInvoiceTeplateWithNullTerminal ? props.id : null;
	const terminalId = props.isDefaultDocTemplate ? props.id : null;
	const enumObj = props.isDefaultDocTemplate
		? DefaultDocumentTemplateType
		: props.isDefaultInvoiceTeplateWithNullTerminal
		? InvoiceDocumentTemplateType
		: CustomerDocumentTemplateType;

	const translate = useTranslate();

	const infoDialogToggle = () => {
		setIsInfoDialogOpen((prev) => !prev);
	};

	return (
		<>
			<Box display="flex" justifyContent="right" padding={1}>
				<AddDocumentTemplate companyId={companyId} terminalId={terminalId} enumObj={enumObj} />
			</Box>
			<Datagrid>
				<TextField source="id" label="resources.document-template.fields.id" />
				<TextField source="name" label="resources.document-template.fields.name" />
				<SelectEnumField
					source="type"
					label="resources.document-template.fields.type"
					enumName="document-template-type"
					enumObj={enumObj}
				/>
				<DateTimeField source="created_at" withLocalTimeZone />
				<FunctionField
					source=""
					render={(record) => (
						<UpdateDocumentTemplate
							document_template={record}
							is_file_update={false}
							enumObj={enumObj}
						/>
					)}
				/>
				<FunctionField
					source=""
					render={(record) => (
						<UpdateDocumentTemplate
							document_template={record}
							is_file_update={true}
							companyId={companyId}
						/>
					)}
				/>
				<DownloadButton buttonLabel={translate("resources.document-template.button.file")} />
				<TheTemplateInfoPreviewButton
					setSelectedRecord={setSelectedRecord}
					translate={translate}
					infoDialogToggle={infoDialogToggle}
				/>
				<DeleteButton
					resource={props.resource}
					notifyMessage="osfc.dialogs.confirm_delete_document_template.success"
					title="osfc.dialogs.confirm_delete_document_template.confirm.title"
					content="osfc.dialogs.confirm_delete_document_template.confirm.content"
				/>
			</Datagrid>
			{isInfoDialogOpen && (
				<TemplateInfoPreviewDialog
					translate={translate}
					documentTemplateType={selectedRecord?.type}
					onInfoDialogClose={infoDialogToggle}
					companyId={companyId}
				/>
			)}
		</>
	);
};
